import styled from 'styled-components';

const Signal = styled.div`
  display: flex;
`;

export default Signal;
